export interface DialogueAudioTrack {
  timelineStartMs: number
  durationMs?: number
}

export interface DialogueTrackPosition {
  state: 'pending' | 'active' | 'ended'
  localMs: number
}

export function dialogueTrackPosition(
  globalMs: number,
  track: DialogueAudioTrack,
  packageDurationMs: number,
): DialogueTrackPosition {
  const startMs = Math.max(0, track.timelineStartMs)
  const durationMs = Math.max(0, track.durationMs ?? packageDurationMs - startMs)
  if (globalMs < startMs) return { state: 'pending', localMs: 0 }
  if (globalMs >= startMs + durationMs) return { state: 'ended', localMs: durationMs }
  return { state: 'active', localMs: globalMs - startMs }
}
